import { type IAdvertise } from "../../../store/slices/advertisesSlice";
import { type IOffer } from "../../../store/slices/offersSlice";
import { type Unit } from "../../../store/slices/unitsSlice";
import { type User } from "../../../store/slices/userSlice";
import { type IViewing } from "../../../store/slices/viewingsSlice";
import { store } from "../../../store/store";
import { USER_ID_KEY } from "../../../urls";



const getActualUnits = () => {
    const storeUnits = store.getState().units.units;
    const sortedUnitIds = storeUnits.reduce<{ bsoUnits: number[]; landlordsUnits: number[] }>(
        (acc, un) => {
            if (un.attributes.ManagedBy === "BSO") {
                acc.bsoUnits.push(un.id);
            } else if (un.attributes.ManagedBy === "Landlord" || un.attributes.Statuses?.includes('Landlord Unit')) {
                acc.landlordsUnits.push(un.id);
            }
            return acc;
        },
        { bsoUnits: [], landlordsUnits: [] } 
    );
    return sortedUnitIds
}



export const getBelongsUnitForAdvertise = (currentAdvertise: IAdvertise) => {
    const userID = window.localStorage.getItem(USER_ID_KEY);
  
        


    const task = {
        type: "TYPE UNIT",
        color: "secondary",
    };
    if (
        currentAdvertise.attributes?.Unit?.data?.attributes?.User?.data?.id ===
        Number(userID)
    ) {
        task.type = "MY UNIT";
        task.color = "primary";
    }
    if (
        currentAdvertise?.attributes?.User?.data?.id === Number(userID) &&
        getActualUnits().bsoUnits.includes(currentAdvertise?.attributes?.Unit?.data?.id as number)
    ) {
        task.type = "BSO UNIT";
        task.color = "warning";
    }
    return task;
};
export const getBelongsUnitForViewing = (currentViewing: IViewing) => {
     




    const userID = window.localStorage.getItem(USER_ID_KEY);
   
    const task = {
        type: "TYPE UNIT",
        color: "secondary",
    };
    if (
        currentViewing.attributes?.Unit?.data?.attributes?.User?.data?.id ===
        Number(userID)
    ) {
        task.type = "MY UNIT";
        task.color = "primary";
    }
    if (
        currentViewing?.attributes?.User?.data?.id === Number(userID) &&
        getActualUnits().bsoUnits.includes(
            currentViewing?.attributes?.Unit?.data?.id as number
        )
    ) {
        task.type = "BSO UNIT";
        task.color = "warning";
    }
    if (
        currentViewing?.attributes?.User?.data?.id === Number(userID) &&
        currentViewing?.attributes?.AgentToAgentID &&
        !getActualUnits().bsoUnits.includes(currentViewing?.attributes?.Unit?.data?.id as number)
    ) {
        task.type = "OTHER AGENT UNIT";
        task.color = "info";
    }  if ( currentViewing?.attributes?.User?.data?.id === Number(userID) &&
    getActualUnits().landlordsUnits.includes(
        currentViewing?.attributes?.Unit?.data?.id as number
    )
    ) {
        task.type = "LANDLORD UNIT";
        task.color = "warning";
    }
    return task;
};

export const getBelongsUnitForOffer = (currentOffer: IOffer) => {
    const userID = window.localStorage.getItem(USER_ID_KEY);
 
    const currentUser = store.getState().user.currentUser;
    const agentUnitsIds = (currentUser as User)?.Units != null &&
        Array.isArray(currentUser?.Units) &&
        currentUser?.Units?.length > 0
        ? currentUser?.Units.map((_unit: Unit) => _unit.id)
        : [];

    const task = {
        type: "TYPE UNIT",
        color: "secondary",
        redirect: "catalog",
    };

    if (currentOffer?.attributes?.Unit?.data?.attributes?.User?.data?.id === Number(userID) &&
        Number(userID) !== Number(process.env.REACT_APP_BSO_USER_ID)) {
        task.type = "MY UNIT";
        task.color = "primary";
        task.redirect = "my_unit";
    }

    if (Number(userID) === Number(process.env.REACT_APP_BSO_USER_ID)) {
        if (
            getActualUnits().bsoUnits.includes(currentOffer?.attributes?.Unit?.data?.id as number) ||
            Number(userID) === Number(process.env.REACT_APP_BSO_USER_ID)
        ) {
            task.type = "BSO UNIT";
            task.color = "warning";
            task.redirect = "catalog";
        }
    } else {
        if (
            currentOffer?.attributes?.User?.data?.id === Number(userID) &&
            (getActualUnits().bsoUnits.includes(currentOffer?.attributes?.Unit?.data?.id as number) ||
                Number(userID) === Number(process.env.REACT_APP_BSO_USER_ID))
        ) {
            task.type = "BSO UNIT";
            task.color = "warning";
            task.redirect = "catalog";
        }
        
    }

    if (
        currentOffer?.attributes?.User?.data?.id === Number(userID)
         && !agentUnitsIds.includes(currentOffer?.attributes?.Unit?.data?.id as number) 
         && !getActualUnits().bsoUnits.includes(currentOffer?.attributes?.Unit?.data?.id as number) 
         && Number(userID) !== Number(process.env.REACT_APP_BSO_USER_ID)
    ) {
        task.type = "OTHER AGENT UNIT";
        task.color = "info";
        task.redirect = "other_agent_s_unit";
    }
    if ( currentOffer?.attributes?.User?.data?.id === Number(userID) && 
    getActualUnits().landlordsUnits.includes(currentOffer?.attributes?.Unit?.data?.id as number)
    ) {
        task.type = "LANDLORD UNIT";
        task.color = "warning";
        task.redirect = "other_landlord_s_unit";
    }
    return task
}
